import { axios } from '@/lib/axios';
import { useQuery,useMutation } from 'react-query';

import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

import { ProductResponse } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';


export type DTO1 = {
    page: number;
    perPage: number;
    search?: string;
    filter?: any;
};

export const getUserList = (
    {  page, perPage, search, filter }: DTO1 = {
      page: 1,
      perPage: 200,
    }
  ): Promise<ProductResponse> => {
    return axios.post(`/marketing/product-list`,  {
      page,
      perPage,
      search,
      filter
     });
  };


type UseOptions = {
  config?: MutationConfig<typeof getUserList>;
};

export const useGetProductList= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getUserList,
  });
};






export type DTO11 = {
  page: number;
  perPage: number;
  search?: string;
  filter?: any;
};

export const getQuoteList = (
  {  page, perPage, search, filter }: DTO11 = {
    page: 1,
    perPage: 20,
  }
): Promise<ProductResponse> => {
  return axios.post(`/marketing/quote-list`,  {
    page,
    perPage,
    search,
    filter
   });
};


type UseOptionss = {
config?: MutationConfig<typeof getQuoteList>;
};

export const useGetQuotesList= ({ config }: UseOptions = {}) => {
return useMutation({
  ...config,
  mutationFn: getQuoteList,
});
};




export type DTO131 = {
  page: number;
  perPage: number;
  search?: string;
  filter?: any;
};

export const getUserLists = (
  {  page, perPage, search, filter }: DTO131 = {
    page: 1,
    perPage: 20,
  }
): Promise<ProductResponse> => {
  return axios.post(`/marketing/user-list`,  {
    page,
    perPage,
    search,
    filter
   });
};


type UseOptionsss = {
config?: MutationConfig<typeof getUserLists>;
};

export const useGetUsersListForQuotes= ({ config }: UseOptionsss = {}) => {
return useMutation({
  ...config,
  mutationFn: getUserLists,
});
};






export type DTO1311 = {
  page: number;
  perPage: number;
  search?: string;
  filter?: any;
};

export const getInstiuteList = (
  {  page, perPage, search, filter }: DTO1311 = {
    page: 1,
    perPage: 20,
  }
): Promise<ProductResponse> => {
  return axios.post(`/marketing/institute-list`,  {
    page,
    perPage,
    search,
    filter
   });
};


type UseOptionsssq = {
config?: MutationConfig<typeof getInstiuteList>;
};

export const useGetInstituteList= ({ config }: UseOptionsssq = {}) => {
return useMutation({
  ...config,
  mutationFn: getInstiuteList,
});
};


